<template>
  <v-card>
    <v-card-title class="white py-5 px-8 grey--text text--darken-2" style="border-bottom: 1px solid #eee !important">
      <v-icon class="ml-3">mdi-file-find</v-icon>
      عدد المشاهدات اخر 30 يوم
      <v-spacer />
      <v-btn
        icon
        large
        text
        class="mx-2"
        title="تصدير لإكسيل"
        color="green darken-2"
        @click="SET_FILTERS({ type: 'visitors-views' }); SHOW_EXPORT_DIALOG()"
      >
        <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="py-7">
      <v-container>
        <v-progress-linear
          v-if="loading"
          color="primary"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
        <pageViews-chart
          v-else
          :options="options"
          :chart-data="chartData"
        ></pageViews-chart>
      </v-container>
    </v-card-text>
  </v-card>
</template>


<script>
import { mapState, mapMutations } from 'vuex';
import PageViewsChart from './PageViewsChart.js'

export default {
  name: 'chart-statistics',
  props: ['statistics', 'loading'],
  components: { PageViewsChart },
  
  data: function () {
    return {
      chartData: null,
      options: {
        responsive: true,
        legend: { display: false },
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            scaleLabel: { display: true, labelString: 'عدد المشاهدات' }
          }],
          xAxes: [{
            scaleLabel: { display: true, labelString: 'الأيام' }
          }]
        }
      }
    }
  },


  watch: {
    statistics: {
      handler(days) {
        if (!days) return;

        const labels = [];
        const values = [];

        for (const day of days) {
          labels.push(day.date);
          values.push(day.pageViews);
        }

        this.chartData = {
          labels: labels,
          datasets: [
            {
              fill: true,
              data: values,
              label: 'عدد المشاهدات',
              backgroundColor: '#0da2ce',
              pointBorderColor: '#0da2ce',
              pointBackgroundColor: '#0da2ce',
            }
          ]
        };
      },
      immediate: true
    }
  },


  methods: {
    ...mapMutations(
      'statistics', ['SHOW_EXPORT_DIALOG', 'SET_FILTERS']
    )
  }
}
</script>
